import React, { useState } from "react";
import "./UploadUserImg.css";
import { useLocation, useNavigate } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import SendBodyPhoto from "../../Components/SendBodyPhoto/SendBodyPhoto";

export default function UploadUserImg() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, planType } = location.state || {};
  const [selectedImages, setSelectedImages] = useState({
    front_pic: "",
    side_pic: "",
    back_pic: "",
  });
  const [imgFiles, setImgFiles] = useState({
    front_pic: null,
    side_pic: null,
    back_pic: null,
  });

  const handleSend = () => {
    navigate("/bodyMeasurements", { state: { selectedImages, formId: id, planType: planType } });
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper uploadUserImg">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="uploadUserImgTop">
            <div className="pageTitle horizontalBorder">
              ارزیابی پزشکی{" "}
              <img
                src="/images/report.svg"
                alt="report icon"
                className="reportIcon"
              />
            </div>
            <span className="uploadUserImgText">
              لطفا در صورت امکان، جهت راهنمایی بهتر، از بدن خود عکس بگیرید.
            </span>
            <SendBodyPhoto
              selectedImages={selectedImages}
              setSelectedImages={setSelectedImages}
              imgFiles={imgFiles}
              setImgFiles={setImgFiles}
            />
          </div>
          <button className="nextQuestion" onClick={handleSend}>
            ارسال
          </button>
        </div>
      </div>
    </div>
  );
}
